import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _styled$div$withConfi2, _styled$div$withConfi4, _styled$div$withConfi6;

import React from 'react';
import styled from 'styled-components';
import { Button, theme } from '@frameio/vapor';
import { getAuthToken } from '../../utils/auth';
import breakpoints, { sizes } from '../../utils/breakpoints';
import { allFootercolumns, socialLinks } from './links';
import { Frameio } from '../icons';
import { FrameioAdobe } from './logo';
var Wrapper = styled.div.withConfig({
  displayName: "Footer__Wrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-0"
})({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  backgroundColor: '#05040A'
});
var InnerWrapper = styled.div.withConfig({
  displayName: "Footer__InnerWrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-1"
})(function (props) {
  var _ref;

  return _ref = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: props.maxWidth,
    padding: props.columns == 1 && '50px 0',
    margin: props.columns != 1 && '50px !important'
  }, _defineProperty(_ref, breakpoints.xs, {
    margin: props.columns != 1 && '50px !important',
    paddingLeft: props.columns == 1 && 'var(--page-margin)',
    paddingRight: props.columns == 1 && 'var(--page-margin)'
  }), _defineProperty(_ref, breakpoints.sm, {// margin: (props.columns != 1) && '50px 48px !important',
  }), _defineProperty(_ref, breakpoints.md, {// margin: (props.columns != 1) && '50px 24px !important',
  }), _defineProperty(_ref, "a", {
    ':hover': {
      color: theme.colors.palette.whiteA100
    }
  }), _ref;
});
var StyledButton = styled(Button).withConfig({
  displayName: "Footer__StyledButton",
  componentId: "@frameio/developer-components__sc-ylj03w-2"
})({
  width: '112px',
  height: '42px',
  fontWeight: '500',
  fontSize: '14px',
  textTransform: 'uppercase'
});
var LoginButton = styled(StyledButton).withConfig({
  displayName: "Footer__LoginButton",
  componentId: "@frameio/developer-components__sc-ylj03w-3"
})({
  color: '#FFF',
  ':hover': {
    backgroundColor: 'transparent',
    color: '#FFF'
  }
});
var TopFooter = styled.div.withConfig({
  displayName: "Footer__TopFooter",
  componentId: "@frameio/developer-components__sc-ylj03w-4"
})(_defineProperty({
  display: 'flex',
  flexDirection: 'column'
}, breakpoints.md, {
  flexDirection: 'row'
}));
var ColumnWrapper = styled.div.withConfig({
  displayName: "Footer__ColumnWrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-5"
})((_styled$div$withConfi2 = {
  display: 'grid',
  width: '100%',
  gridGap: '2%',
  gridAutoFlow: 'row',
  gridTemplateColumns: '49% 49%'
}, _defineProperty(_styled$div$withConfi2, breakpoints.xs, {
  gridAutoFlow: 'row'
}), _defineProperty(_styled$div$withConfi2, breakpoints.sm, {
  gridAutoFlow: 'row',
  gridTemplateColumns: '23.5% 23.5% 23.5% 23.5%'
}), _styled$div$withConfi2));
var StyledColumn = styled.div.withConfig({
  displayName: "Footer__StyledColumn",
  componentId: "@frameio/developer-components__sc-ylj03w-6"
})({
  maxWidth: '100%',
  span: {
    display: 'block'
  },
  '> span': _defineProperty({
    color: '#FFFFFF',
    textTransform: 'uppercase',
    paddingBottom: '20px',
    display: 'inline-flex',
    fontSize: '16px',
    letterSpacing: '1px'
  }, breakpoints.md, {
    padding: '15px 0'
  }),
  'div span': {
    color: '#9A9AAC',
    fontSize: '14px',
    lineHeight: '30px'
  }
});
var BottomFooter = styled.div.withConfig({
  displayName: "Footer__BottomFooter",
  componentId: "@frameio/developer-components__sc-ylj03w-7"
})(_defineProperty({
  display: 'grid',
  gridTemplateColumns: 'auto',
  gridTemplateRows: 'auto',
  justifyContent: 'center',
  gridGap: '1.5rem',
  paddingTop: '3rem'
}, breakpoints.sm, {
  gridGap: '2rem',
  gridTemplateRows: '1fr',
  gridTemplateColumns: '1fr auto 1fr',
  placeItems: 'center'
}));
var LinkWrapper = styled.div.withConfig({
  displayName: "Footer__LinkWrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-8"
})({
  display: 'flex',
  flexDirection: 'column'
});
var ColumnHeader = styled.h4.withConfig({
  displayName: "Footer__ColumnHeader",
  componentId: "@frameio/developer-components__sc-ylj03w-9"
})({
  color: '#FFF',
  fontSize: '18px',
  fontWeight: '400',
  marginTop: '0',
  paddingTop: '12px',
  paddingBottom: '16px',
  marginBottom: '0'
});
var Divider = styled.div.withConfig({
  displayName: "Footer__Divider",
  componentId: "@frameio/developer-components__sc-ylj03w-10"
})({
  borderBottom: '1px solid rgb(50, 55, 69)',
  marginBottom: '10px'
});
var ButtonWrapper = styled.div.withConfig({
  displayName: "Footer__ButtonWrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-11"
})((_styled$div$withConfi4 = {
  display: 'flex',
  paddingLeft: '0',
  paddingTop: '2rem',
  width: 'fit-content',
  margin: '10px auto'
}, _defineProperty(_styled$div$withConfi4, breakpoints.sm, {
  margin: '0 auto',
  paddingLeft: '0',
  paddingTop: '0'
}), _defineProperty(_styled$div$withConfi4, breakpoints.md, {
  paddingLeft: '30px'
}), _defineProperty(_styled$div$withConfi4, "button", {
  padding: '15px',
  margin: '5px'
}), _styled$div$withConfi4));
var OutboundLink = styled.a.withConfig({
  displayName: "Footer__OutboundLink",
  componentId: "@frameio/developer-components__sc-ylj03w-12"
})({
  textDecoration: 'none',
  color: theme.colors.palette.grey70,
  fontSize: '14px',
  lineHeight: '28px',
  fontWeight: 500,
  outline: 'none'
});
var CoreLinks = styled.div.withConfig({
  displayName: "Footer__CoreLinks",
  componentId: "@frameio/developer-components__sc-ylj03w-13"
})(_defineProperty({
  justifySelf: 'start',
  minWidth: '280px',
  fontSize: '14px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  '> a': {
    textDecoration: 'none',
    oultine: 'none',
    color: theme.colors.palette.grey70,
    padding: '8px 16px 8px 0'
  }
}, breakpoints.sm, {
  justifyContent: 'left'
}));
var SocialLinkWrapper = styled.div.withConfig({
  displayName: "Footer__SocialLinkWrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-14"
})((_styled$div$withConfi6 = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gridRow: 1
}, _defineProperty(_styled$div$withConfi6, breakpoints.sm, {
  justifySelf: 'end',
  gridRow: 'auto'
}), _defineProperty(_styled$div$withConfi6, '> a', {
  padding: '5px 10px 0 10px'
}), _styled$div$withConfi6));
var LinkIcon = styled.div.withConfig({
  displayName: "Footer__LinkIcon",
  componentId: "@frameio/developer-components__sc-ylj03w-15"
})({
  ':hover': {
    '> svg': {
      fill: theme.colors.palette.whiteA100
    }
  }
});
var DesktopLogoWrapper = styled.div.withConfig({
  displayName: "Footer__DesktopLogoWrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-16"
})(_defineProperty({
  justifySelf: 'center',
  height: '50px',
  display: 'none'
}, breakpoints.md, {
  display: 'flex'
}));
var MobileLogoWrapper = styled.div.withConfig({
  displayName: "Footer__MobileLogoWrapper",
  componentId: "@frameio/developer-components__sc-ylj03w-17"
})(_defineProperty({
  justifySelf: 'center',
  display: 'flex'
}, breakpoints.md, {
  display: 'none'
}));
var maxWidth;

var Footer = function Footer(_ref2) {
  var columns = _ref2.columns;

  switch (columns) {
    case 3:
      maxWidth = 'calc(1800px - 30rem)';
      break;

    case 2:
      maxWidth = 'none';
      break;

    case 1:
      maxWidth = '1200px';
      break;

    default:
      maxWidth = '100%';
  }

  var isLoggedIn = getAuthToken();
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(InnerWrapper, {
    maxWidth: maxWidth,
    columns: columns
  }, /*#__PURE__*/React.createElement(TopFooter, null, /*#__PURE__*/React.createElement(ColumnWrapper, null, allFootercolumns.map(function (column) {
    return /*#__PURE__*/React.createElement(StyledColumn, {
      key: column.name
    }, /*#__PURE__*/React.createElement(ColumnHeader, null, column.name), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(LinkWrapper, null, column.links.map(function (link) {
      return /*#__PURE__*/React.createElement(OutboundLink, {
        key: link.name,
        href: link.link,
        title: link.name
      }, link.name);
    })));
  })), !isLoggedIn && /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(LoginButton, {
    href: "https://app.frame.io/",
    id: "login",
    variant: "ghost"
  }, "Log In"), /*#__PURE__*/React.createElement(StyledButton, {
    href: "https://accounts.frame.io/welcome",
    id: "signup",
    color: "primary"
  }, "Sign Up"))), /*#__PURE__*/React.createElement(BottomFooter, null, /*#__PURE__*/React.createElement(CoreLinks, null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.adobe.com/"
  }, "\xA9 2023 Adobe. All rights reserved."), /*#__PURE__*/React.createElement("a", {
    href: "https://www.frame.io/terms/"
  }, "Terms"), /*#__PURE__*/React.createElement("a", {
    href: "https://www.frame.io/privacy/"
  }, "Privacy")), /*#__PURE__*/React.createElement(DesktopLogoWrapper, null, /*#__PURE__*/React.createElement(FrameioAdobe, null)), /*#__PURE__*/React.createElement(MobileLogoWrapper, null, /*#__PURE__*/React.createElement(Frameio, null)), /*#__PURE__*/React.createElement(SocialLinkWrapper, null, socialLinks.map(function (social) {
    return /*#__PURE__*/React.createElement(OutboundLink, {
      key: social.name,
      href: social.link,
      title: social.name
    }, /*#__PURE__*/React.createElement(LinkIcon, null, social.icon));
  })))));
};

export default Footer;